@let userInfo = applicationStore.userInfo();

<div class="p-5 border border-gray-200 rounded-2xl dark:border-gray-800 lg:p-6">
  <div class="flex flex-col gap-6 lg:flex-row lg:items-start lg:justify-between">
    <div>
      <h4 class="text-lg font-semibold text-gray-800 dark:text-white/90 lg:mb-6">
        {{ 'app.label.account' | translate }}
      </h4>
      <div class="grid grid-cols-1 gap-4 lg:grid-cols-2 lg:gap-7 2xl:gap-x-32">
        <div>
          <p class="mb-2 text-xs leading-normal text-gray-500 dark:text-gray-400">
            {{ 'app.label.market' | translate }}
          </p>
          <p class="text-sm font-medium text-gray-800 dark:text-white/90">
            {{ userInfo['market'] }}
          </p>
        </div>
        <div>
          <p class="mb-2 text-xs leading-normal text-gray-500 dark:text-gray-400">
            Other
          </p>
          <p class="text-sm font-medium text-gray-800 dark:text-white/90">
            ...
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
